module.exports = __webpack_public_path__ + "static/media/raven_funny_09.eab94ed0.svg";